import { defineStore } from 'pinia'

export default defineStore("callbacks", {
  state: ()=>({
    callbacks: [],
  }),
  getters: {
    lastCallback(state) {
      return state.callbacks[state.callbacks.length-1] || null;
    },
  },
  actions: {
    pushCallback(callback) {
      this.callbacks.push(callback);
    },
    popCallback() {
      this.callbacks.pop();
    },
  },
});
